<template>
    <v-row justify="center">
        <v-dialog max-width="500px" persistent v-model="showPopup.show">
            <v-card>
                <v-card-title class="blue">
                    <v-icon class="pa-1 mr-1" color="indigo darken-3">far fa-plus-square</v-icon>
                    <span class="headline"> <v-icon></v-icon> Lizenz hinzufügen </span>
                </v-card-title>
                <v-card-text>
                    <v-container class="mt-4">
                        <v-form ref="form">
                            <v-row>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :rules="inputRules" class="my-0 py-0" label="Nummer" required
                                                  v-mask="'###'" v-model="data.LicCount"></v-text-field>
                                </v-col>

                                <v-col class="my-0 py-0" cols="6">
                                    <v-text-field :rules="rabattRules" class="my-0 py-0" label="OrderDiscount"
                                                  suffix="%" v-if="data.CreateOrder" v-mask="'###'"
                                                  v-model="data.OrderDiscount"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="6">
                                    <v-text-field class="my-0 py-0" label="Tax" suffix="%" v-if="data.CreateOrder"
                                                  v-mask="'###'" v-model="data.Tax"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-textarea class="my-0 py-0" label="Kommentar"
                                                v-model="data.Kommentar"></v-textarea>

                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn @click="showPopup.show = false" color="blue darken-1" text>Schließen</v-btn>
                    <v-btn :disabled="loading" :loading="loading" @click="submit" color="green darken-1" text>
                        Speichern
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import moment from 'moment'
    import {HTTP} from "../http";
    import {mask} from 'vue-the-mask'
    import {EventBus} from "../eventbus";


    export default {
        directives: {
            mask,
        },
        props: {
            showPopup: Object,
            customerId: String
        },
        data() {
            return {
                data: {
                    CustomerID: this.customerId,
                    LicCount: 1,
                    OrderDiscount: 0,
                    Tax: 19,
                    CreateOrder: false
                },
                inputRules: [
                    v => !!v || 'Darf nicht leer sein'
                ],
                rabattRules: [
                    v => (0 <= parseInt(v) && parseInt(v) <= 100) || 'Rabatt muss zwischen 0 und 100 sein.'
                ],
                loading: false,
            }
        },
        methods: {
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    HTTP.post("api/Licence/add", this.data).then(() => {
                        this.loading = false;
                        EventBus.$emit('reload');
                        this.showPopup.show = false;
                    }).catch(() => {
                        this.loading = false;
                    })

                }
            }
        },
        computed: {
            formattedDate() {
                return this.due ? moment(this.due).format('DD MMM YYYY') : ''
            }
        }
    }
</script>
